import { render, staticRenderFns } from "./certifiSelection.vue?vue&type=template&id=a3e53e22&scoped=true&"
import script from "./certifiSelection.vue?vue&type=script&lang=js&"
export * from "./certifiSelection.vue?vue&type=script&lang=js&"
import style0 from "./certifiSelection.vue?vue&type=style&index=0&id=a3e53e22&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e53e22",
  null
  
)

export default component.exports